// Chakra imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Spacer,
  Text,
  useColorModeValue,
  Skeleton,
  Box,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import React, { useEffect, useState } from "react";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";
// react icons
import { BsArrowRight } from "react-icons/bs";

const BuiltByDevelopers = ({ title, name, description, image }) => {
  const textColor = useColorModeValue("gray.700", "white");
  const secondTextColor = useColorModeValue("gray.500", "gray.100");
  const [announcement, setAnnouncement] = useState("");
  useEffect(() => {
    axios
      .get(apiUrl + "/data/announcement", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setAnnouncement(response.data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  }, []);

  const renderMarkdown = (text) => {
    const parts = text.split(/(\*\*|__|~~|`)/);
    const elements = [];
    let isBold = false;
    let isItalic = false;
    let isStrikethrough = false;
    let isCode = false;

    parts.forEach((part, index) => {
      switch (part) {
        case "**":
          isBold = !isBold;
          break;
        case "__":
          isItalic = !isItalic;
          break;
        case "~~":
          isStrikethrough = !isStrikethrough;
          break;
        case "`":
          isCode = !isCode;
          break;
        default:
          let element = part;
          if (isBold) element = <b key={index}>{element}</b>;
          if (isItalic) element = <i key={index}>{element}</i>;
          if (isStrikethrough) element = <s key={index}>{element}</s>;
          if (isCode) element = <code key={index}>{element}</code>;
          elements.push(element);
          break;
      }
    });

    return elements;
  };

  return (
    <Card maxHeight="290.5px" p="1.2rem">
      <CardBody w="100%">
        <Flex flexDirection={{ sm: "column", lg: "row" }} w="100%">
          <Flex
            flexDirection="column"
            h="100%"
            lineHeight="1.6"
            width={{ lg: "90%" }}
          >
            <Text fontSize="lg" color={textColor} fontWeight="bold" pb=".5rem">
              Ostatnie ogłoszenie
            </Text>
            <Skeleton isLoaded={announcement}>
              <Flex flexDirection={"row"}>
                <Avatar
                  name={announcement.sender}
                  src={announcement.senderAvatar}
                  mr={"15px"}
                />
                <Flex flexDirection={"column"}>
                  <Text fontSize={"m"} color={textColor} fontWeight="bold">
                    {announcement.sender}
                  </Text>
                  <Box style={{ maxHeight: 200, overflow: "scroll" }}>
                    <Text
                      style={{ whiteSpace: "pre-line" }}
                      fontSize="sm"
                      color={secondTextColor}
                      fontWeight="normal"
                    >
                      {announcement.text && renderMarkdown(announcement.text)}
                    </Text>
                  </Box>
                </Flex>
              </Flex>
            </Skeleton>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default BuiltByDevelopers;
